import { render, staticRenderFns } from "./KDSInvoice.vue?vue&type=template&id=1d38985e&scoped=true"
import script from "./KDSInvoice.vue?vue&type=script&lang=js"
export * from "./KDSInvoice.vue?vue&type=script&lang=js"
import style0 from "./KDSInvoice.vue?vue&type=style&index=0&id=1d38985e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d38985e",
  null
  
)

export default component.exports